/**
 * @file appLoader - native 简版引入方式异步导入
 * @author weijiaxun <weijiaxun@baidu.com>
 */
import nativeContainer from './registedEntry';
const nativeMethodCaller = nativeContainer.init({
    // 声明业务上需要使用的方法
    jsApiList: ['getZid', 'getCuid', 'login', 'share', 'initShare', 'copyText', 'getAppInstall', 'launch3rdApp', 'getVersion', 'guidePush', 'initBack', 'goBack', 'openWebview', 'shareCommand', 'getPushStatus', 'openPush', 'downloadCSS', 'openSwan']
});
const getActiveAppName = nativeContainer.getActiveAppName;
export default nativeMethodCaller;
export { getActiveAppName };
export const { share, getZid, getCuid, login, initShare, copyText, getAppInstall, launch3rdApp, getVersion, openPush, guidePush, goBack, initBack, openWebview, shareCommand, downloadCSS, getPushStatus, openSwan } = nativeMethodCaller;
//# sourceMappingURL=appLoader.js.map